import React from 'react';
import { BaseScenarioLayout } from './base/BaseScenarioLayout';
import { PerformanceScenarioLayout as LifeSuiteLayout } from './performance/PerformanceScenarioLayout';
import { BodyImageScenarioLayout } from './body-image/BodyImageScenarioLayout';
import { SessionBox } from '../SessionBox/SessionBox';
import { ConnectedDevices, SessionCharts } from '../index';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type { DeviceConnectionStatus, Device } from '@types';

interface ScenarioLayoutProps {
  session: DeviceConfigurationApi;
  appRequirements: { vr: boolean; sensor: boolean };
  allDevices: Device[];
  connectionStatus: Record<string, DeviceConnectionStatus>;
  onConfigureClick: () => void;
  isLoading: boolean;
}

type ScenarioLayoutComponent = React.ComponentType<ScenarioLayoutProps>;

export const getScenarioLayout = (
  type: string | undefined
): ScenarioLayoutComponent => {
  switch (type) {
    case 'performance':
    case 'exposure':
      return LifeSuiteLayout;
    case 'body_image':
      return BodyImageScenarioLayout;
    default:
      return LifeExperienceLayout;
  }
};

const LifeExperienceLayout: React.FC<ScenarioLayoutProps> = ({
  session,
  appRequirements,
  allDevices,
  connectionStatus,
  onConfigureClick,
  isLoading,
}) => {
  const sessionBox = (
    <SessionBox
      session={session}
      appRequirements={appRequirements}
      allDevices={allDevices}
      connectionStatus={connectionStatus}
      isLoading={isLoading}
    />
  );

  const devicesBox = (
    <ConnectedDevices
      onConfigureClick={onConfigureClick}
      vrRequired={appRequirements.vr}
      sensorRequired={appRequirements.sensor}
      devices={allDevices}
      session={session}
    />
  );

  const chartBox = <SessionCharts session={session} />;

  return (
    <BaseScenarioLayout
      session={session}
      sessionBox={sessionBox}
      devicesBox={devicesBox}
      chartBox={chartBox}
    />
  );
};
